import React, { Component } from 'react';
import {connect} from 'react-redux';
import * as R from 'ramda';
import KeyBoardContainer from '../styled/KeyBoardContainer';
import KeyBoardGroup from '../styled/KeyBoardGroup';
import SuperButton from './SuperButton';
import { checkChar } from  '../store/actions';

const BoardKey = ({word, status, onClick}) => (
  <SuperButton
    width={'50px'}
    height={'50px'}
    status={status}
    onClick={onClick}
  >
    {word}
  </SuperButton>
);

@connect(state => {
  return {
    keyboard: Object.keys(state.game.keyboard),
    keys: state.game.keyboard,
  }
})
class KeyBoard extends Component {
  render() {
    const arrWordsInGroup = R.splitEvery(5, this.props.keyboard);

    const keys = arrWordsInGroup.map((group, idx) => (
      <KeyBoardGroup key={idx}>
        {group.map(key => (
          <BoardKey
            key={key}
            word={key}
            status={this.props.keys[key]}
            onClick={() => {if (this.props.keys[key] === 0) this.props.dispatch(checkChar(key))}}
          />
        ))}
      </KeyBoardGroup>
    ));

    return (
      <KeyBoardContainer>
        {keys}
      </KeyBoardContainer>
    );
  }
}

export default KeyBoard;
